import filterConstants from '../constants';

const reportsTimeProject = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsTimeProject,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.portfolio_id]: '',
    [filterConstants.PROPERTY.text]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
    [filterConstants.PROPERTY.assignee]: '',
  },
});

export default reportsTimeProject;
